// extracted by mini-css-extract-plugin
export default {"groupNameForm":"group-name-form_groupNameForm__BX5si"};